import { render, staticRenderFns } from "./VerificationPicker.vue?vue&type=template&id=056bf08a&scoped=true&"
import script from "./VerificationPicker.vue?vue&type=script&lang=ts&"
export * from "./VerificationPicker.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "056bf08a",
  null
  
)

export default component.exports